module.exports = __webpack_public_path__ + "img/copy.28a58936.svg";